import React from 'react';

const stats = [
  {
    id: 1,
    heading: 'Live',
    label: 'Expert Mentors',
  },
  {
    id: 2,
    heading: 'Build',
    label: 'Professional Projects',
  },
  {
    id: 3,
    heading: 'Solve',
    label: '150+ DSA problems',
  },
  {
    id: 4,
    heading: 'Get 5+',
    label: 'Assured Interviews',
  },
  {
    id: 5,
    heading: '6 Months',
    label: 'Live + Recorded',
  },
  {
    id: 6,
    heading: 'Internship',
    label: 'Experience Certificate',
  },
];

// DA program no longer includes DSA, so swap that stat for DA pages
const dataAnalyticsStat = {
  id: 3,
  heading: 'Solve',
  label: 'SQL & Python Problems',
};

const HeroStatsPanel = ({ isDataAnalytics = false }) => {
  const visibleStats = isDataAnalytics
    ? stats.map((stat) => (stat.id === 3 ? dataAnalyticsStat : stat))
    : stats;

  return (
    <div className="mx-auto max-w-7xl pb-6 md:mt-8">
      <div className="grid grid-cols-2 overflow-hidden rounded-3xl bg-[#E6F4F2] shadow-xl md:flex md:w-full md:overflow-x-auto md:p-6">
        {visibleStats.map((stat, idx) => (
          <React.Fragment key={stat.id}>
            <div
              className={`flex flex-col items-center border-b-2 border-[#10B981] border-opacity-20 p-4 text-center ${
                idx % 2 === 1 ? 'border-l-2' : ''
              } ${idx >= 4 ? 'border-b-0' : ''} md:border-none md:px-6 md:py-2`}
            >
              <div className="mb-1 font-manrope text-base font-extrabold text-v5-green-300 md:text-2xl">
                {stat.heading}
              </div>
              <div className="font-manrope text-sm font-extrabold text-black md:text-xl">
                {stat.label}
              </div>
            </div>
            {idx !== visibleStats.length - 1 && idx % 2 === 1 && idx < 4 && (
              <div className="col-span-2 border-b-2 border-[#10B981] border-opacity-20 md:hidden"></div>
            )}
            {idx !== visibleStats.length - 1 && (
              <div className="mx-1 hidden h-16  self-center border-r-2 border-v5-neutral-400 border-opacity-20 md:block"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default HeroStatsPanel;
